import CookieManager from '~/utils/Cookie'
import errorHandler from '~/mixins/error-handler'

export default {
  mixins: [errorHandler],
  props: {
    redirectOnLoginSuccess: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    redirectBack() {
      const orderNumber = this.$route.query.orderNumber
      if (orderNumber) {
        this.$router.push('/orders/' + orderNumber)
      } else {
        let afterLogin = '/'
        if (CookieManager.Client().get('after_login')) {
          afterLogin = CookieManager.Client().get('after_login')
          document.cookie = 'after_login='
        }
        if (this.redirectOnLoginSuccess) this.$router.push(afterLogin)
      }
    },
    emitSuccess() {
      this.$emit('success')
    },
  },
}
